import React from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import classNames from "classnames";
import { formSubmitButton } from "@/assets/styles/common.module.scss";

const RedirectModal = ({
  show,
  onConfirm,
  title = "Premium Recalculation",
  message = "You’ll be redirected to the Proposal Page, where your premium will be recalculated based on the package and cover changes you’ve made.",
}) => {
  return (
    <Modal
      show={show}
      centered
      backdrop="static"
      keyboard={false}
      onHide={() => {}}
    >
      <Modal.Body className="px-4 py-4 text-center">
        <div className="boldContentClass5 mb-3">{title}</div>
        <div className="mb-4">{message}</div>

        <div className="d-flex justify-content-center">
          <button
            type="button"
            className={classNames("btn rounded-pill px-5", formSubmitButton)}
            onClick={onConfirm}
          >
            Okay
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

RedirectModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
};

export default RedirectModal;